import React, { useEffect, useState } from "react";
import { ResponsiveContainer, LineChart, Line, XAxis, YAxis, Tooltip } from "recharts";
import api from "@/lib/api";
import { fmtEUR2, fmtDate } from "@/lib/format";
import { CARD, Loader, ErrorRetry } from "@/components/common";
import { Input } from "@/components/ui/input";

function Row({ r }) {
  const [open, setOpen] = useState(false);
  const up = (r.change_pct || 0) > 0;
  return (
    <div className="px-5 py-3.5">
      <button type="button" onClick={() => setOpen(!open)} disabled={r.count < 2} data-testid="price-row" className="flex w-full items-center justify-between gap-3 text-left">
        <div className="min-w-0"><p className="truncate font-semibold">{r.designation}</p><p className="text-xs text-gray-400">{r.supplier} · {r.count} achat(s) · dernier le {fmtDate(r.last_date)}</p></div>
        <div className="shrink-0 text-right">
          <p className="font-semibold tabular-nums">{fmtEUR2(r.last_price)} HT</p>
          {r.change_pct != null ? <p className={`text-xs font-semibold ${up ? "text-amber-600" : r.change_pct < 0 ? "text-emerald-600" : "text-gray-400"}`}>{up ? "+" : ""}{r.change_pct} % vs achat précédent</p> : <p className="text-xs text-gray-400">Un seul achat</p>}
        </div>
      </button>
      {open && (
        <div className="mt-3 h-36" data-testid="price-chart"><ResponsiveContainer width="100%" height="100%">
          <LineChart data={r.points.map((p) => ({ name: fmtDate(p.date), prix: p.unit_price }))}>
            <XAxis dataKey="name" tick={{ fontSize: 10 }} axisLine={false} tickLine={false} /><YAxis tick={{ fontSize: 10 }} axisLine={false} tickLine={false} width={40} domain={["auto", "auto"]} />
            <Tooltip formatter={(v) => fmtEUR2(v)} /><Line dataKey="prix" stroke="#B08D57" strokeWidth={2} dot={{ r: 3 }} />
          </LineChart></ResponsiveContainer>
          <p className="text-xs text-gray-400">Depuis le premier achat : {r.total_change_pct > 0 ? "+" : ""}{r.total_change_pct} % · moyenne {fmtEUR2(r.avg_price)}</p></div>)}
    </div>
  );
}

export function Prices() {
  const [rows, setRows] = useState(null);
  const [q, setQ] = useState("");
  const [err, setErr] = useState(0);
  useEffect(() => { const t = setTimeout(() => { api.get("/pilotage/prices", { params: { q } }).then((r) => { setRows(r.data); setErr(0); }).catch(() => setErr((e) => e || 1)); }, 250); return () => clearTimeout(t); }, [q, err]);
  return (
    <div className="space-y-4">
      <div className="flex flex-wrap items-center gap-3">
        <Input placeholder="Rechercher un article ou un fournisseur" value={q} onChange={(e) => setQ(e.target.value)} className="max-w-sm rounded-full" data-testid="price-search" />
        <p className="text-xs text-gray-500">Prix unitaires HT lus sur les lignes de facture. Cliquez sur un article acheté plusieurs fois pour voir sa courbe.</p>
      </div>
      {err && !rows ? <ErrorRetry onRetry={() => setErr(err + 1)} /> : !rows ? <Loader /> : (
        <div className={`${CARD} divide-y divide-gray-100 overflow-hidden`} data-testid="price-list">
          {rows.map((r) => <Row key={r.key} r={r} />)}
          {!rows.length && <p className="p-8 text-center text-sm text-gray-400">Aucun article suivi. Le suivi démarre dès que vos factures ont des lignes détaillées (pensez à la reprise historique en Pré-comptabilité).</p>}
        </div>)}
    </div>
  );
}
